import Vue from 'vue'
import Vuex from 'vuex'
// import router from '@/router'
import i18n from '@/i18n'
// import Qs from 'qs'
import _ from 'lodash'
// import { getField, updateField } from 'vuex-map-fields'
import { MessageBox, Message } from 'element-ui'
import router from '@/router'

import dayjs from 'dayjs'

import owlsight from 'owlsight/src/tailwind.js'

// modules
import metadata from '@/store/modules/metadata'
import home from '@/store/modules/home'
import hotels from '@/store/modules/hotels'
import promotion from '@/store/modules/promotion'
import search from '@/store/modules/search'
import user from '@/store/modules/user'
import order from '@/store/modules/order'
import events from '@/store/modules/events'
import socket from '@/store/modules/socket'
import voucher from '@/store/modules/voucher.js'

import yokoso from '@/store/modules/yokoso'

import createPersistedState from 'vuex-persistedstate'
import rehydrated from './rehydrated.js'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const transLang = (code) => {
  if (code === 'zh_tw') return 'zh-TW'
  if (code === 'zh_cn') return 'zh-CN'
  return code
}

export default new Vuex.Store({
  strict: debug,
  modules: {
    metadata,
    home,
    hotels,
    promotion,
    search,
    user,
    order,
    events,
    socket,
    yokoso,
    voucher
  },
  plugins: [
    createPersistedState({
      key: 'owlJourney',
      rehydrated: rehydrated,
      // storage: window.sessionStorage,
      paths: [
        'redirectUrl',
        'user.token',
        'user.userPath',
        'user.selectedLang',
        'user.selectedCurrency',
        'user.prevStepIsLogout'
        // 'order.startDate',
        // 'order.endDate',
        // 'order.carts',
        // 'order.discount',
        // 'search.filters',
        // 'search.autoComplete',
        // 'search.startDate',
        // 'search.endDate',
        // 'search.options'
      ]
    }),
    store => {
      let prevState = _.cloneDeep(store.state)
      store.subscribe((mutation, state) => {
        const urlReplace = function () {
          const people = {
            adult: state.search.filters.adult,
            child: state.search.filters.child,
            childAge: state.search.filters.childAge
          }
          if (router.currentRoute.name) {
            router.push({
              ...router.currentRoute,
              query: {
                ...router.currentRoute.query,
                ...people
              }
            })
          }
        }
        const updatePeopleToURL = _.debounce(urlReplace, 1000)
        const watcher = {
          'route/ROUTE_CHANGED': function () {
            console.debug('route/ROUTE_CHANGED', mutation.payload)
          },
          'search/SET_CHILD_AGE': function () {
            updatePeopleToURL()
          },
          'search/RESET_CHILD_AGE': function () {
            updatePeopleToURL()
          },
          'search/REPLACE_CHILD_AGES': function () {
            updatePeopleToURL()
          },
          'search/updateField': async function () {
            console.debug('order/updateField', mutation.payload.path, mutation.payload.value)
            if (mutation.payload.path === 'filters.adult') {
              updatePeopleToURL()
            }
            if (mutation.payload.path === 'filters.child') {
              await store.commit('search/UPDATE_CHILD_AGE_LENGTH', { val: mutation.payload.value, oldVal: prevState.search.filters.child })
              updatePeopleToURL()
            }
            if (mutation.payload.path === 'filters.childAge') {
            }
          },
          'search/SET_DATE_RANGE': function () {
            const startChange = prevState.search.startDate !== null && !dayjs(prevState.search.startDate).isSame(dayjs(store.state.search.startDate), 'day')
            const endChange = prevState.search.endDate !== null && !dayjs(prevState.search.endDate).isSame(dayjs(store.state.search.endDate), 'day')
            if (startChange || endChange) {
              if (!_.isEmpty(store.getters['order/inCart'])) {
                MessageBox.alert(`變更日期將清除已選房型，請重新選取～`, '您的購物車已有選取的房型', {
                  confirmButtonText: '好',
                  showClose: false,
                  type: 'warning'
                }).then(() => {
                  store.commit('order/CLEAR_CARTS')
                  Message({
                    type: 'success',
                    message: '購物車已清空'
                  })
                })
              }
            }
          },
          'order/SET_DATE_RANGE': function () {
            const startChange = prevState.order.startDate !== null && !dayjs(prevState.order.startDate).isSame(dayjs(store.state.order.startDate), 'day')
            const endChange = prevState.order.endDate !== null && !dayjs(prevState.order.endDate).isSame(dayjs(store.state.order.endDate), 'day')
            if (startChange || endChange) {
              if (!_.isEmpty(store.getters['order/inCart'])) {
                store.commit('order/CLEAR_CARTS')
              }
            }
          }
        }
        if (watcher[mutation.type]) {
          watcher[mutation.type]()
        }
        let nextState = _.cloneDeep(state)
        prevState = nextState
      })
      return store
    }
  ],
  state: {
    initWidth: 0,
    windowWidth: 1280,
    windowHeight: 1080,
    redirectUrl: null,
    isSuper: false,
    currencyExist: null,
    currencySelectable: null,
    scrollTop: null
  },
  getters: {
    // getField,
    isSuper: (state) => {
      return state.isSuper
    },
    initWidth: (state) => {
      return state.initWidth
    },
    windowWidth: (state) => {
      if (state && state.windowWidth) {
        return state.windowWidth
      }
      return 1280
    },
    windowHeight: (state) => {
      if (state && state.windowHeight) {
        return state.windowHeight
      }
      return 1080
    },
    isTouchDevice: () => {
      return (
        !!(typeof window !== 'undefined' &&
          ('ontouchstart' in window ||
            (window.DocumentTouch &&
              typeof document !== 'undefined' &&
              document instanceof window.DocumentTouch))) ||
        !!(typeof navigator !== 'undefined' &&
          (navigator.maxTouchPoints || navigator.msMaxTouchPoints))
      )
    },
    currencyExist: (state) => {
      return state.currencyExist
    },
    currencySelectable: (state) => {
      return state.currencySelectable
    },
    scrollTop: (state) => {
      return state.scrollTop
    },
    isDesktop: (state) => {
      // > 992px
      return state.windowWidth >= owlsight.screens.lg.substring(0, 3)
    },
    isTablet: (state) => {
      // >= 768px && < 992px
      return state.windowWidth >= owlsight.screens.md.substring(0, 3) &&
        state.windowWidth < owlsight.screens.lg.substring(0, 3)
    },
    isMobile: (state) => {
      // < 768px
      return state.windowWidth < owlsight.screens.md.substring(0, 3)
    },
    datePickerLocale: (state) => {
      return transLang(_.snakeCase(i18n.locale))
    },
    isDrawerSize: (state) => {
      return state.windowWidth < 480
    },
    isSuperTasteHeroSize: (state) => {
      return state.windowWidth < 420
    },
    isFiveOneTwoSize: (state) => {
      return state.windowWidth < 512
    }
  },
  actions: {
    redirect: function ({ commit, state }) {
      if (state.redirectUrl) {
        const url = _.cloneDeep(state.redirectUrl)
        commit('SET_REDIRECT_URL', null)
        window.location = url
      } else {
        window.location = process.env.BASE_URL || '/'
      }
    },
    bodyLock: function ({ commit }, bool) {
      bool
        ? document.body.classList.add('body-lock')
        : document.body.classList.remove('body-lock')
    }
  },
  mutations: {
    // updateField,
    SET_SUPER (state, payload) {
      state.isSuper = payload
    },
    SET_WINDOW_WIDTH (state, payload) {
      if (payload) {
        state.windowWidth = payload
        if (state.initWidth === 0) {
          state.initWidth = payload
        }
      }
    },
    SET_WINDOW_HEIGHT (state, payload) {
      if (payload) {
        state.windowHeight = payload
      }
    },
    SET_REDIRECT_URL (state, payload) {
      state.redirectUrl = payload
    },
    SET_CURRENCY_EXIST (state, payload) {
      state.currencyExist = payload
    },
    SET_CURRENCY_SELECTABLE (state, payload) {
      state.currencySelectable = payload
    },
    SET_SCROLL_TOP (state, payload) {
      state.scrollTop = payload
    }
  }
})
